/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, ContractFactory, Signer } from "ethers";
import { Provider } from "ethers/providers";
import { UnsignedTransaction } from "ethers/utils/transaction";
import { Arrayish, BigNumberish } from "ethers/utils";

import { TransactionOverrides } from "..";
import { StakingPool } from "../StakingPool";

export class StakingPool__factory extends ContractFactory {
  constructor(signer?: Signer) {
    super(_abi, _bytecode, signer);
  }

  deploy(
    _minStakingPeriod: BigNumberish,
    _withdrawDelay: BigNumberish,
    _claimManager: string,
    _patronRoles: Arrayish[],
    _rewardPool: string,
    _patronRewardPortion: BigNumberish,
    overrides?: TransactionOverrides
  ): Promise<StakingPool> {
    return super.deploy(
      _minStakingPeriod,
      _withdrawDelay,
      _claimManager,
      _patronRoles,
      _rewardPool,
      _patronRewardPortion,
      overrides
    ) as Promise<StakingPool>;
  }
  getDeployTransaction(
    _minStakingPeriod: BigNumberish,
    _withdrawDelay: BigNumberish,
    _claimManager: string,
    _patronRoles: Arrayish[],
    _rewardPool: string,
    _patronRewardPortion: BigNumberish,
    overrides?: TransactionOverrides
  ): UnsignedTransaction {
    return super.getDeployTransaction(
      _minStakingPeriod,
      _withdrawDelay,
      _claimManager,
      _patronRoles,
      _rewardPool,
      _patronRewardPortion,
      overrides
    );
  }
  attach(address: string): StakingPool {
    return super.attach(address) as StakingPool;
  }
  connect(signer: Signer): StakingPool__factory {
    return super.connect(signer) as StakingPool__factory;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): StakingPool {
    return new Contract(address, _abi, signerOrProvider) as StakingPool;
  }
}

const _abi = [
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_minStakingPeriod",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_withdrawDelay",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "_claimManager",
        type: "address",
      },
      {
        internalType: "bytes32[]",
        name: "_patronRoles",
        type: "bytes32[]",
      },
      {
        internalType: "address payable",
        name: "_rewardPool",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_patronRewardPortion",
        type: "uint256",
      },
    ],
    stateMutability: "payable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "patron",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "timestamp",
        type: "uint256",
      },
    ],
    name: "StakePut",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "patron",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "timestamp",
        type: "uint256",
      },
    ],
    name: "StakeWithdrawalRequested",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "patron",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "timestamp",
        type: "uint256",
      },
    ],
    name: "StakeWithdrawn",
    type: "event",
  },
  {
    inputs: [],
    name: "minStakingPeriod",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "stakes",
    outputs: [
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "depositStart",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "depositEnd",
        type: "uint256",
      },
      {
        internalType: "enum StakingPool.StakeStatus",
        name: "status",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "totalStake",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "withdrawDelay",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "putStake",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [],
    name: "requestWithdraw",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "withdraw",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "checkReward",
    outputs: [
      {
        internalType: "uint256",
        name: "reward",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

const _bytecode =
  "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";
